const nf = new Intl.NumberFormat('pt-BR');
const cf = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
const pfCache = new Map<number, Intl.NumberFormat>();
function pf(digits: number) {
  let f = pfCache.get(digits);
  if (!f) {
    f = new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: digits, maximumFractionDigits: digits });
    pfCache.set(digits, f);
  }
  return f;
}

export const fmtInt = (n: number): string => nf.format(Math.round(n));
export const fmtCurrency = (n: number): string => cf.format(n);
export const fmtPercent = (n: number, digits = 1): string => pf(digits).format(n / 100);

export function fmtDuration(seconds: number): string {
  const s = Math.round(seconds);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  const r = s % 60;
  return r === 0 ? `${m}min` : `${m}m${r}s`;
}

export function fmtAge(seconds: number): string {
  if (seconds < 60) return `${Math.round(seconds)}s`;
  if (seconds < 3600) return `${Math.round(seconds / 60)}min`;
  return `${Math.round(seconds / 3600)}h`;
}
